/*
  INNOVIA STUDIO, eventi del sito.
  Questo file non contiene pixel e non invia dati a nessuna piattaforma.
  Pubblica soltanto eventi interni di Shopify: sono i pixel personalizzati,
  configurati in Impostazioni, Eventi dei clienti, a decidere se inoltrarli,
  e lo fanno solo nel rispetto del consenso espresso dal visitatore.
  Non vengono mai pubblicati nome, email, telefono o testo del messaggio.
*/
(function () {
  "use strict";

  var STORE_KEY = "innovia_origine";
  var DURATA_GIORNI = 90;

  /* ------------------------------------------------ consenso

     La memoria del browser viene usata soltanto se il visitatore ha dato
     il consenso alla misurazione o al marketing. Senza consenso l'origine
     resta in memoria per la sola pagina aperta e non viene mai salvata.
  */

  function consensoOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      var an = typeof cp.analyticsProcessingAllowed === "function" ? cp.analyticsProcessingAllowed() : false;
      var mk = typeof cp.marketingAllowed === "function" ? cp.marketingAllowed() : false;
      return !!(an || mk);
    } catch (e) {
      return false;
    }
  }

  function dimenticaOrigine() {
    try {
      window.localStorage.removeItem(STORE_KEY);
    } catch (e) {
      /* niente da fare */
    }
  }

  function publish(nome, dati) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(nome, dati || {});
      }
    } catch (e) {
      /* il sito continua a funzionare anche se il tracciamento non parte */
    }
  }

  /* ------------------------------------------------ origine e campagna */

  function leggiOrigine() {
    if (!consensoOk()) return null;
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.salvato_il) return null;
      if (Date.now() - o.salvato_il > DURATA_GIORNI * 86400000) return null;
      return o;
    } catch (e) {
      return null;
    }
  }

  function calcolaOrigine() {
    var p = new URLSearchParams(window.location.search);
    var utm = {
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      utm_content: p.get("utm_content") || "",
      utm_term: p.get("utm_term") || ""
    };
    var haUtm = utm.utm_source || utm.utm_medium || utm.utm_campaign;
    var esistente = leggiOrigine();

    /* La prima origine utile viene conservata e non sovrascritta dalle visite successive. */
    if (esistente && !haUtm) return esistente;
    if (esistente && haUtm && esistente.utm_source) return esistente;

    var ref = document.referrer || "";
    var refHost = "";
    try {
      refHost = ref ? new URL(ref).hostname.replace(/^www\./, "") : "";
    } catch (e) {
      refHost = "";
    }
    var interno = refHost && refHost.indexOf(window.location.hostname.replace(/^www\./, "")) !== -1;

    var provenienza;
    if (haUtm) provenienza = utm.utm_source + (utm.utm_medium ? " / " + utm.utm_medium : "");
    else if (!ref || interno) provenienza = "diretto";
    else provenienza = refHost;

    var o = {
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_content: utm.utm_content,
      utm_term: utm.utm_term,
      provenienza: provenienza,
      referrer: interno ? "" : refHost,
      prima_pagina: window.location.pathname + window.location.search,
      salvato_il: Date.now()
    };
    if (consensoOk()) {
      try {
        window.localStorage.setItem(STORE_KEY, JSON.stringify(o));
      } catch (e) {
        /* navigazione privata o storage pieno */
      }
    }
    return o;
  }

  var origine = calcolaOrigine() || {};

  /* Quando il visitatore esprime la sua scelta, la memoria viene allineata:
     salvata se accetta, cancellata se rifiuta o revoca. */
  function riallinea() {
    if (consensoOk()) {
      try {
        if (!window.localStorage.getItem(STORE_KEY) && origine && origine.salvato_il) {
          window.localStorage.setItem(STORE_KEY, JSON.stringify(origine));
        }
      } catch (e) {
        /* navigazione privata o storage pieno */
      }
    } else {
      dimenticaOrigine();
    }
  }

  document.addEventListener("visitorConsentCollected", riallinea);

  /* Carica l'interfaccia del consenso di Shopify, cosi la verifica e possibile
     anche nelle aree geografiche in cui il banner non viene mostrato. */
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        riallinea();
      });
    }
  } catch (e) {
    /* senza l'interfaccia del consenso non viene salvato nulla */
  }

  function conOrigine(dati) {
    dati = dati || {};
    dati.page_location = window.location.pathname;
    dati.campaign_source = origine.utm_source || "";
    dati.campaign_medium = origine.utm_medium || "";
    dati.campaign_name = origine.utm_campaign || "";
    return dati;
  }

  /* Riempie i campi nascosti dei moduli di contatto, cosi l'origine arriva anche nel CRM. */
  function compilaCampiNascosti() {
    var mappa = {
      "contact[utm_source]": origine.utm_source || "",
      "contact[utm_medium]": origine.utm_medium || "",
      "contact[utm_campaign]": origine.utm_campaign || "",
      "contact[utm_content]": origine.utm_content || "",
      "contact[utm_term]": origine.utm_term || "",
      "contact[provenienza]": origine.provenienza || "",
      "contact[prima pagina]": origine.prima_pagina || "",
      "contact[pagina del modulo]": window.location.pathname
    };
    Object.keys(mappa).forEach(function (nome) {
      var campi = document.querySelectorAll('input[name="' + nome.replace(/"/g, '\\"') + '"]');
      for (var i = 0; i < campi.length; i++) campi[i].value = mappa[nome];
    });
  }

  /* ------------------------------------------------ click sui pulsanti */

  var PREZZI = { analisi: 297, sito: 999 };

  function tipoCheckout(href) {
    if (!href) return null;
    if (href.indexOf("64165539611001") !== -1) return "analisi";
    if (href.indexOf("64165539348857") !== -1) return "sito";
    return null;
  }

  document.addEventListener("click", function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest("a") : null;
    if (!a) return;
    var href = a.getAttribute("href") || "";

    var tipo = tipoCheckout(href);
    if (tipo === "analisi") {
      publish("click_analysis_checkout", conOrigine({
        service_name: "Analisi Ecommerce",
        package_name: "Analisi Ecommerce",
        package_price: PREZZI.analisi
      }));
      return;
    }
    if (tipo === "sito") {
      publish("click_website_checkout", conOrigine({
        service_name: "Sito web moderno su una sola pagina",
        package_name: "Sito web moderno su una sola pagina",
        package_price: PREZZI.sito
      }));
      return;
    }

    if (href.indexOf("mailto:") === 0) {
      publish("click_email", conOrigine({ lead_type: "email" }));
      return;
    }

    var pacchetto = a.getAttribute("data-package");
    if (pacchetto || href.indexOf("#contatto") !== -1) {
      publish("click_quote_request", conOrigine({
        service_name: pacchetto || "Non specificato",
        lead_type: "preventivo"
      }));
    }
  }, true);

  /* Scelta del pacchetto o del servizio nel modulo */
  var selettore = document.getElementById("pacchettoSelect");
  if (selettore) {
    selettore.addEventListener("change", function () {
      publish("select_service", conOrigine({ service_name: selettore.value }));
    });
  }
  var tabPacchetti = document.querySelectorAll("[data-package]");
  for (var t = 0; t < tabPacchetti.length; t++) {
    (function (el) {
      el.addEventListener("click", function () {
        publish("select_service", conOrigine({ service_name: el.getAttribute("data-package") || "" }));
      });
    })(tabPacchetti[t]);
  }

  /* ------------------------------------------------ video della prima schermata */

  var video = document.getElementById("ugcVideo");
  if (video) {
    var partito = false;
    var meta = false;
    var completato = false;
    var titolo = "Video UGC, prima schermata";

    video.addEventListener("playing", function () {
      if (partito) return;
      partito = true;
      publish("video_start", conOrigine({ video_title: titolo }));
    });
    video.addEventListener("timeupdate", function () {
      if (!video.duration || !isFinite(video.duration)) return;
      var perc = video.currentTime / video.duration;
      if (!meta && perc >= 0.5) {
        meta = true;
        publish("video_progress", conOrigine({ video_title: titolo, video_percent: 50 }));
      }
      if (!completato && perc >= 0.95) {
        completato = true;
        publish("video_complete", conOrigine({ video_title: titolo }));
      }
    });
    /* il video e in ripetizione: azzera i contatori a ogni giro */
    video.addEventListener("seeked", function () {
      if (video.currentTime < 0.3) {
        meta = false;
        completato = false;
      }
    });
  }

  /* ------------------------------------------------ avvio */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", compilaCampiNascosti);
  } else {
    compilaCampiNascosti();
  }

  /* generate_lead viene pubblicato dal tema soltanto sulla schermata di conferma. */
  window.innoviaLeadInviato = function (servizio) {
    publish("generate_lead", conOrigine({
      lead_type: "modulo_contatto",
      service_name: servizio || ""
    }));
  };
})();
